/**
 * Module that handles displaying and navigating the steps of the action item creation wizard
 */
define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/actions/actionGroup/actionItemModal/actionItemStep/actionItemStepView",
], function (Marionette, Backbone, Messenger, ActionItemStepView) {
  var ActionItemStepModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "actionItemStep";
      this.region = options.region;
      this.editMode = options.editMode;
    },
    setActiveStep: function (stepNum) {
      this.actionStepModel.set("step", stepNum);
    },
    setActionItemType: function (actionItemType) {
      this.actionStepModel.set("actionType", actionItemType);
    },
    show: function () {
      this.actionStepModel = new Backbone.Model({ actionType: "", step: 1 });
      this.actionStepModel.set("editMode", this.editMode);
      this.view = new ActionItemStepView.actionItemStepView({ model: this.actionStepModel });
      this.showRegion(this.view);
    },
  });

  return ActionItemStepModule;
});
